var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.08 4.00059C18.9072 3.70121 18.6598 3.45172 18.3618 3.27646C18.0639 3.1012 17.7256 3.00615 17.38 3.00059H4.58L4 0.740587C3.9414 0.522425 3.81066 0.330531 3.62908 0.196158C3.44749 0.0617862 3.22576 -0.00714676 3 0.00058648H1C0.734784 0.00058648 0.48043 0.105943 0.292893 0.29348C0.105357 0.481016 0 0.73537 0 1.00059C0 1.2658 0.105357 1.52016 0.292893 1.70769C0.48043 1.89523 0.734784 2.00059 1 2.00059H2.24L5 12.2606C5.0586 12.4787 5.18934 12.6706 5.37092 12.805C5.55251 12.9394 5.77424 13.0083 6 13.0006H15C15.1847 13 15.3656 12.9483 15.5227 12.8513C15.6798 12.7542 15.8069 12.6155 15.89 12.4506L19.17 5.89059C19.3122 5.5926 19.3783 5.26406 19.3626 4.93427C19.3469 4.60448 19.2498 4.28371 19.08 4.00059Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 18.0006C6.32843 18.0006 7 17.329 7 16.5006C7 15.6722 6.32843 15.0006 5.5 15.0006C4.67157 15.0006 4 15.6722 4 16.5006C4 17.329 4.67157 18.0006 5.5 18.0006Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 18.0006C16.3284 18.0006 17 17.329 17 16.5006C17 15.6722 16.3284 15.0006 15.5 15.0006C14.6716 15.0006 14 15.6722 14 16.5006C14 17.329 14.6716 18.0006 15.5 18.0006Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.89adbd1df9b2dfbe9ff77d53bb160d9a.svg";
export { ForwardRef as ReactComponent };